import { useState, CSSProperties, useEffect } from "react";
import { View } from "react-native";
import { ReactComponent as RadioButtonActiveImg } from '../../img/btn-radio-incon-check-active.svg';
import { ReactComponent as RadioButtonInactiveImg } from '../../img/btn-radio-incon-check-inactive.svg';


export interface RadioButtonType {
    id: string,
    size: number,
    label: string,
    checked: boolean,
    labelStyle?: CSSProperties
}

interface CustomRadioBtnProps {
    id: string,
    size: number,
    label: string,
    type: string,
    checked: boolean,
    selectCb: Function,
    activeYn?: boolean,
    labelStyle?: CSSProperties
}

export default function CustomRadioBtn(props: CustomRadioBtnProps) {
    const labelText = props.label;
    const checkBoxId = props.id;
    const checkBoxType = props.type;
    const [activeYn, setActiveYn] = useState(props.checked);
    const [radioButtonImgStyle, setRadioButtonImgStyle] = useState(className.radioButtonImg);

    useEffect(() => {
        if(props.activeYn === false) {
            setRadioButtonImgStyle({...radioButtonImgStyle, width: props.size + "px", height: props.size + "px", cursor: ""});
        } else {
            setRadioButtonImgStyle({...radioButtonImgStyle, width: props.size + "px", height: props.size + "px", cursor: "pointer"});
        }
        
    }, []);


    useEffect(() => {
        if(props.checked != activeYn) {
            setActiveYn(props.checked);
        }
    }, [props.checked]);

    function setCheck(checkedYn) {
        if(activeYn) {
            return ;
        }
        setActiveYn(checkedYn);
        props.selectCb(checkBoxId, checkBoxType);
    }
    return (
        <label>
            <input style={className.radioButton}
                id={props.label}
                type={"checkbox"}
                checked={activeYn}
                disabled={props.activeYn === false}
                onChange={(e) => { setCheck(e.target.checked); }}
            />
            <View style={{flexDirection: "row", alignItems: "center"}}>
                {
                    activeYn ?
                    <RadioButtonActiveImg style={radioButtonImgStyle} /> : <RadioButtonInactiveImg style={radioButtonImgStyle} />
                }
                <label htmlFor={props.label} style={props.labelStyle}>{labelText}</label>
            </View>
        </label>
        
    );
}

const className = {
    radioButton: {
        border: "0px",
        width: "0px",
        height: "0px",
        display: "none"
    },
    radioButtonImg: {
        width: "22px", height: "22px",
        marginRight: "10px",
        cursor: "pointer"
    }
};